export const LOGGED_IN = 'LOGGED_IN';
export const LOG_OUT = 'LOG_OUT';
export const APP_NAME = 'ELECNOR OBJETIVOS/TENDENCIAS';

let Entornos = {
	Desarrollo: 'development',
	PreProduccion: 'pre-production',
	Produccion: 'production'
};

/* DESARROLLO */
export let APP_URL_ROOT = '/';
export let API_ENDPOINT = 'http://localhost:50000/api';

/* DESARROLLO TIRANDO DEL API DE PRE-PRODUCCION */
if (process.env.NODE_ENV === Entornos.Desarrollo && process.env.REACT_APP_ENVIROMENT === Entornos.PreProduccion) {
	//API_ENDPOINT = `http://ipdesa-2012:8081/ElecnorCAv3/api/v1/`;
}

if (process.env.NODE_ENV === Entornos.Produccion) {
	/* PRODCUCCION */
	APP_URL_ROOT = '/';
	API_ENDPOINT = `${APP_URL_ROOT}api`;
}